import { render } from "./Mechas.vue?vue&type=template&id=2922a6e4&scoped=true"
const script = {}

import "./Mechas.vue?vue&type=style&index=0&id=2922a6e4&scoped=true&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2922a6e4"]])

export default __exports__